import { useCallback, useRef, useState } from "react";

/** Etiquetas Rep. 1, Rep. 2… sin huecos ni números repetidos. */
export function conEtiquetasRep(panes) {
    return panes.map((p, i) => ({
        ...p,
        label: `Rep. ${i + 1}`,
        forceRender: true,
    }));
}

/**
 * Pestañas de repeticiones (CMJ, Nordic, Dynamo).
 * @param {React.ComponentType<{ atleta: object }>} RepComponent
 * @param {object} atleta
 */
export default function useRepsTabs(RepComponent, atleta) {
    const [reps, setReps] = useState([]);
    const [repActual, setRepActual] = useState(null);
    const idRepRef = useRef(0);

    const agregarRep = useCallback(() => {
        if (!atleta?._id) return;
        const key = ++idRepRef.current;
        setReps((prev) =>
            conEtiquetasRep([...prev, { key, children: <RepComponent atleta={atleta} repKey={key} /> }])
        );
        setRepActual(key);
    }, [RepComponent, atleta]);

    const borrarRep = useCallback(
        (targetKey) => {
            let newActiveKey = repActual;
            let lastIndex = -1;
            reps.forEach((item, i) => {
                if (item.key === targetKey) {
                    lastIndex = i - 1;
                }
            });
            const newPanes = conEtiquetasRep(reps.filter((item) => item.key !== targetKey));
            if (newPanes.length && newActiveKey === targetKey) {
                newActiveKey = lastIndex >= 0 ? newPanes[lastIndex].key : newPanes[0].key;
            }
            setReps(newPanes);
            setRepActual(newActiveKey);
        },
        [repActual, reps]
    );

    const onEdit = useCallback(
        (targetKey, action) => {
            if (action === "add") {
                agregarRep();
            } else {
                borrarRep(targetKey);
            }
        },
        [agregarRep, borrarRep]
    );

    return {
        reps,
        repActual,
        setRepActual,
        agregarRep,
        onEdit,
    };
}
